import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function returnIfSuspended(argument, $completion) {
  return (argument == null ? true : !(argument == null)) ? argument : THROW_CCE();
}
//region block: exports
export {
  returnIfSuspended as returnIfSuspended1blqheeew1z6h,
};
//endregion

//# sourceMappingURL=coroutineInternalJS.mjs.map
